import React from 'react';
import { Grid, Paper, Dialog, Typography, withStyles, Button } from '@material-ui/core';
import { styles } from './DownloadPage';
import { BackButton, hasPermission } from '../sc-utilities';
import AppLogoLoading from '../sc-logo';
import { connect } from 'react-redux';
import playstore from './png/play_store.png';
import appstore from './png/app_store.png';
import GetAppIcon from '@material-ui/icons/GetApp';

const Motion = (props) => {
    const { classes, translations, permissions } = props;
    const icon = (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#7485FF"
                d="M37.8549 29.1228L22.6154 38.425L6.82729 29.2444L6.46154 25.718H13.1669V25.7788L22.6154 31.3723L31.6372 25.718L30.2351 8.99826L11.2772 9.11986L12.1306 16.5373H19.5065L18.5922 15.747L19.9332 14.531L24.7489 19.6381L19.8723 24.7452L18.5922 23.4076L19.3846 22.6781L1.76778 22.7389L0 16.5373H5.42525L3.59652 0.0607991L10.5457 0L10.8505 2.85756L17.434 2.91836L17.1292 0.0607991H23.225L23.5298 2.91836H29.4427L29.1988 0.0607991H35.2946L37.8549 29.1228Z"
            />
        </svg>
    );

    return (
        <Paper className={classes.root}>
            {hasPermission(permissions, 'binary_image_download') && (
                <>
                    <div className={classes.customToolbar}>
                        <div className={classes.tableTitle}>
                            {BackButton(translations, classes.customTooltip)}
                            <Typography className={classes.typography}>
                                {translations['downloads'] || 'Downloads'}
                            </Typography>
                        </div>
                    </div>
                    <Grid container direction="row" className={classes.grid}>
                        <Grid item ms={12} lg={6}>
                            <h2>
                                {icon} Motion{' '}
                                <span className={classes.latestVersionSpan}>
                                    - {translations['latest_version'] || 'Latest Version'}
                                </span>
                            </h2>
                            <p>
                                {translations['motion_download_page'] ||
                                    'Smartphone application for inventory management & performing offline erasures with Work. '}
                            </p>
                        </Grid>
                        <Grid item ms={6} lg={6} container direction="column" justify="center" alignItems="center">
                            <Grid container direction="row" spacing={2} className={classes.row} justify="center">
                                <a
                                    href={'https://play.google.com/store/apps/details?id=com.securazemotion'}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={classes.storeButton}
                                >
                                    <img src={playstore} width={145} alt="playstore" />
                                </a>
                                <a
                                    href={'https://apps.apple.com/bs/app/securaze-motion-app/id1552368203'}
                                    target={'_blank'}
                                    rel="noopener noreferrer"
                                    className={classes.storeButton}
                                >
                                    <img src={appstore} width={153} alt="appstore" />
                                </a>
                            </Grid>
                            <Grid container direction="row" spacing={2} className={classes.row} justify="center">
                                <a
                                    href={
                                        'https://securazeeu.blob.core.windows.net/download/motion/release/Securazemotion.apk'
                                    }
                                    className={classes.link}
                                >
                                    <Button color={'primary'} variant={'contained'} className={classes.osDiv}>
                                        <GetAppIcon /> Android Enterprise
                                    </Button>
                                </a>
                                <a
                                    href={
                                        'itms-services:?action=download-manifest&url=https%3A%2F%2Fsecurazeeu.blob.core.windows.net%2Fdownload%2Fmotion%2Frelease%2Fmanifest.plist'
                                    }
                                    className={classes.link}
                                >
                                    <Button color={'primary'} variant={'contained'} className={classes.osDiv}>
                                        <GetAppIcon /> iOS Enterprise
                                    </Button>
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        PaperProps={{
                            classes: {
                                root: classes.loadingScreen,
                            },
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Motion));
